import MoreVertIcon from "@mui/icons-material/MoreVert";
import {Stack} from "@mui/material";
import React from "react";

export default function ContextMenuButton({id, onContextMenuClick}) {
    return (
        <Stack height={"5"} id={id}>
            <Stack height={"2.5"} paddingX={"0.1"} onClick={onContextMenuClick} id={id}>
                <MoreVertIcon
                    sx={{color: "white", margin: "0.125 0 0 0.125", pointerEvents: "none"}}
                />
            </Stack>
        </Stack>
    );
}
